import React, { forwardRef } from "react";
import get from "lodash/get";

import { StyledInputWrapper } from "./simpleTextField.style";
import { ExternalLabel } from "../common.style";
import GenericInputField, {
  TYPES,
  Label,
} from "../../../../genericInputFields/genericInputField";
import { useFormContext } from "react-hook-form";

const SimpleTextField = forwardRef(
  (
    {
      required,
      placeholder,
      maxCharacters,
      name,
      label,
      readOnly,
      value,
      externalLabel,
      useInForm = true,
      ...rest
    },
    ref,
  ) => {
    const {
      register,
      formState: { errors },
    } = useFormContext();
    const error = get(errors, name);
    const withForm = () => {
      if (!useInForm) return null;

      return {
        register: register,
        error: error,
      };
    };

    return (
      <StyledInputWrapper ref={ref}>
        {externalLabel && (
          <ExternalLabel>
            <Label required={required}>{externalLabel}</Label>
          </ExternalLabel>
        )}
        <GenericInputField
          type={TYPES.SIMPLE_LABELED_TEXT}
          {...withForm()}
          {...rest}
          name={name}
          label={label}
          required={required}
          placeholder={placeholder}
          maxCharacters={maxCharacters}
          value={value}
          readOnly={readOnly}
        />
      </StyledInputWrapper>
    );
  },
);
SimpleTextField.displayName = "SimpleTextField";

export default SimpleTextField;
